import { ProductTypes } from 'products-data';
import { STANDARD_PRODUCT_DETAIL_VIEW_COMPONENTS, STANDARD_PRODUCT_RESULT_VIEW_COMPONENTS } from './standard/component-provider/tokens';
import { WIRE_CUT_PRODUCT_DETAIL_VIEW_COMPONENTS, WIRE_CUT_PRODUCT_RESULT_VIEW_COMPONENTS } from './wire-cut/component-provider/tokens';

export const PRODUCT_RESULT_VIEW_COMPONENT_TOKENS = {
  [ProductTypes.Standard]: STANDARD_PRODUCT_RESULT_VIEW_COMPONENTS,
  [ProductTypes.Wire]: WIRE_CUT_PRODUCT_RESULT_VIEW_COMPONENTS,
};

export const PRODUCT_DETAIL_VIEW_COMPONENT_TOKENS = {
  [ProductTypes.Standard]: STANDARD_PRODUCT_DETAIL_VIEW_COMPONENTS,
  [ProductTypes.Wire]: WIRE_CUT_PRODUCT_DETAIL_VIEW_COMPONENTS,
};
